import React, { useState } from "react";
import noDataFound from "src/assets/no-data.png";
import { useApiWithAxios } from "src/hooks/useApi";
import CONSTANTS from "src/components/services/api";
import loaderAnimation from "src/assets/loaderAnimation.gif";
import { ChatCardCoach } from "src/components/molecules/ChatCard";
import StandardSearch from "src/components/atoms/inputfields/StandardSearch";

const AdminList = ({ onSelectCoach, bearerToken }) => {
  const [selected, setSelected] = useState(null);
  const [searchText, setSearchText] = useState("");

  const handleClick = (id) => {
    setSelected(id);
    onSelectCoach(id);
  };
  const { data, error, loading } = useApiWithAxios(`${CONSTANTS.API_BASE}/coaches`, "GET", null, {
    headers: {
      Authorization: bearerToken ? bearerToken : CONSTANTS.BearerToken,
    },
  });

  // if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error?.message}</p>;
  const filteredCoaches = data?.data?.filter((coach) => coach?.name?.toLowerCase().includes(searchText.toLowerCase()));

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center h-[80vh]">
          <img src={loaderAnimation} alt="loader" />
        </div>
      ) : (
        <>
          <h2 className="text-[#475569] text-xl font-semibold mb-2">My Coaches</h2>
          <StandardSearch placeholder="Search coaches" onChange={(e) => setSearchText(e.target.value)} />

          {filteredCoaches && filteredCoaches.length > 0 ? (
            filteredCoaches?.map((coach) => (
              <ChatCardCoach
                key={coach.id}
                handler={() => handleClick(coach.id)}
                className={`coach-item ${selected === coach.id ? "selected-coach" : ""}`}
                data={coach}
                btnTitle="See Clients"
              />
            ))
          ) : (
            <div className="flex flex-col justify-center items-center h-[550px] text-gray-500">
              <img src={noDataFound} alt="" />
              <h1 className="font-bold text-[#475569] text-[20px] text-center">No results found</h1>
              <p className="text-[#76767CCC] font-normal text-[12px] md:w-[250px] w-[200px] text-center mt-3">We couldn’t find what you are searched for. Try searching again</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AdminList;
